import { initializeApp, type FirebaseOptions } from 'firebase/app';
import { getMessaging, getToken } from 'firebase/messaging';


const firebaseConfig: FirebaseOptions = {
    apiKey: 'AIzaSyDUZfaQTmSr2IAahdO_U9wBDL3dA_IB-JA',
    authDomain: 'reffie-2282a.firebaseapp.com',
    projectId: 'reffie-2282a',
    storageBucket: 'reffie-2282a.firebasestorage.app',
    messagingSenderId: '629112599038',
    appId: '1:629112599038:web:3c323cac67e535be2c10af',
    measurementId: 'G-XMVNKQ9XY8'
};

export const fbApp = initializeApp(firebaseConfig);

export const getPushToken = async (withPermissionRequest: boolean = true): Promise<string | null> => {
    const messaging = getMessaging(fbApp);

    if (!import.meta.env['VITE_VAPID_PUBLIC_KEY']) {
        console.error('VAPID public key is not set in environment variables');
        return null;
    }

    try {
        const prevRegistration = await navigator.serviceWorker.getRegistration('/firebase-messaging-sw.js');
        if (!prevRegistration) {
            await navigator.serviceWorker.register('/firebase-messaging-sw.js');
        } else {
            await prevRegistration.update();
        }
        const serviceWorkerRegistration = await navigator.serviceWorker.ready;
        const firstTokenAttempt = await getToken(messaging, { vapidKey: import.meta.env['VITE_VAPID_PUBLIC_KEY'], serviceWorkerRegistration});
        if (firstTokenAttempt) {
            return firstTokenAttempt;
        }

        if (withPermissionRequest) {
            const permission = await Notification.requestPermission();

            if (permission === 'granted') {
                return getToken(messaging, { vapidKey: import.meta.env['VITE_VAPID_PUBLIC_KEY'], serviceWorkerRegistration });
            }
        } else {
            return getToken(messaging, { vapidKey: import.meta.env['VITE_VAPID_PUBLIC_KEY'], serviceWorkerRegistration });
        }

        return null;
    } catch (error) {
        console.error('An error occurred while retrieving token. ', error);
        return null;
    }

};
